import { RemoveMessage } from '@/core/helper/validation-rule-helper';
import { t } from 'i18next';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
// import DataGridWrapper from '@/core/wrappers/data-grid-wrapper'; 
import DataGridWrapper from '../../syncflow/components/data-grid-wrapper';
import CustomStore from 'devextreme/data/custom_store';
import React from 'react';
import { Button } from 'devextreme-react/button';
import { DataGrid, Popup, SelectBox, TextBox } from 'devextreme-react';
import { orderService } from '../../platform/services/order-service';
import DateBox, { DateBoxTypes, DisplayFormat } from 'devextreme-react/cjs/date-box';
import { useNavigate } from 'react-router-dom';
import { invoiceService } from '../services/invoice-service';
import { SelectBoxTypes } from 'devextreme-react/cjs/select-box';
import { TextBoxType } from 'devextreme/ui/text_box';
import { TextBoxTypes } from 'devextreme-react/cjs/text-box';
import OrderStatusCell from '@/projects/syncflow/order/components/order-status-celll';
import { paymentService } from '../../platform/services/payment-service';

const InvoiceList = () => {

    let CustomerCode: any;
    let InvoiceNo: any;
    let ProductCode: any;
    let OrderIds: any;
    let StartDate = new Date();
    let EndDate = new Date();

    StartDate.setDate(StartDate.getDate() - 7);

    const dateLabel = { 'aria-label': 'Date' };

    const dataGridRef = useRef<DataGrid>(null);
    const [store, setStore] = useState<CustomStore>();

    useEffect(() => {
        setStore(new CustomStore({
            key: ["id", "invoicePdf","invoiceSlip"],
            load: onGetOrderData,
            useDefaultSearch: true
        }));
    }, [])

    const onGetOrderData = useCallback(async () => {
        const x = await invoiceService.getInvoiceList(InvoiceNo, OrderIds, CustomerCode, ProductCode, StartDate, EndDate);
        return x;
    }, []);

    const onQuery = useCallback(async () => {
        dataGridRef.current?.instance.refresh();
    }, []);

    function add() {
        navigate(`/b2b/invoice-recording/`);
    }

    const onFocusedCellChanging = (e: { isHighlighted: boolean; }) => {
        e.isHighlighted = true;
    };

    const onValueChangedStartDate = useCallback((e: DateBoxTypes.ValueChangedEvent) => {
        StartDate = e.value;
    }, []);

    const onValueChangedEndDate = useCallback((e: DateBoxTypes.ValueChangedEvent) => {
        EndDate = e.value;
    }, []);

    const navigate = useNavigate();
    const goToDetail = (id: string) => {
        navigate(`/b2b/invoice-recording/${id}`, { state: { id: id } })
    }

    const goToDownload = (id: number, fileName: string) => {
        invoiceService.getDownloadInvoicePdf(id, fileName);
    }


    const [vendorLookups] = useState(new CustomStore({
        load: invoiceService.getVendorLookups
    }));



    const [productLookups] = useState(new CustomStore({
        load: invoiceService.getProductLookups
    }));

    const [orderNoLookups] = useState(new CustomStore({
        load: invoiceService.getOrderNoLookups
    }));

    const onValueChangedVendor = useCallback((e: SelectBoxTypes.ValueChangedEvent) => {
        CustomerCode = e.value;
    }, []);



    var [orderNo, setOrderNo] = useState<any>("");
    const onValueChangedInvoiceNo = useCallback((data: TextBoxTypes.ValueChangedEvent) => {
        setOrderNo(data.value);
        InvoiceNo = data.value;
    }, []);

    const onValueChangedProduct = useCallback((e: SelectBoxTypes.ValueChangedEvent) => {
        ProductCode = e.value;
    }, []);

    const onValueChangedOrderNo = useCallback((e: SelectBoxTypes.ValueChangedEvent) => {
        OrderIds = e.value;
    }, []);



    return (
        <>


            <div className='row mb-4 justify-content-end'>
                {/* <div className='col-auto'>
                    <Button
                        text="Add"
                        type="default"
                        icon="add"
                        onClick={add}
                    />
                </div> */}
                <div className='col-auto'>
                    <Button
                        text="Search"
                        type="default"
                        icon="refresh"
                        onClick={onQuery}
                    />
                </div>
            </div>

            <div className="row">
                <label className="col-lg-1 col-form-label fw-bold fs-6">{t("syncflow:lb_start_date")}</label>
                <div className="col-lg-2">
                    <div className="row">
                        <div className="fv-row">
                            <DateBox
                                defaultValue={StartDate}
                                inputAttr={dateLabel}
                                type="date"
                                onValueChanged={onValueChangedStartDate}
                            />
                        </div>
                    </div>
                </div>
                <label className="col-lg-1 col-form-label fw-bold fs-6">{t("syncflow:lb_end_date")}</label>
                <div className="col-lg-2">
                    <div className="row">
                        <div className="fv-row">
                            <DateBox
                                defaultValue={EndDate}
                                inputAttr={dateLabel}
                                type="date"
                                onValueChanged={onValueChangedEndDate}
                            />
                        </div>
                    </div>
                </div>

                <label className="col-lg-1 col-form-label fw-bold fs-6">Customer</label>
                <div className="col-lg-2">
                    <div className="row">
                        <div className="fv-row">
                            <SelectBox
                                name="vendorLookups"
                                dataSource={vendorLookups}
                                valueExpr="code"
                                displayExpr="name"
                                searchEnabled={true}
                                onValueChanged={onValueChangedVendor}
                                showClearButton={true} />
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <label className="col-lg-1 col-form-label fw-bold fs-6">Invoice No</label>
                <div className="col-lg-2">
                    <div className="row">
                        <div className="fv-row">

                            <TextBox
                                showClearButton={true}
                                onValueChanged={onValueChangedInvoiceNo}
                                value={orderNo}
                            />
                        </div>
                    </div>
                </div>
                <label className="col-lg-1 col-form-label fw-bold fs-6">Product</label>
                <div className="col-lg-2">
                    <div className="row">
                        <div className="fv-row">
                            <SelectBox
                                name="vendorLookups"
                                dataSource={productLookups}
                                valueExpr="id"
                                displayExpr="name"
                                searchEnabled={true}
                                onValueChanged={onValueChangedProduct}
                                showClearButton={true} />
                        </div>
                    </div>
                </div>
                <label className="col-lg-1 col-form-label fw-bold fs-6">Order No</label>
                <div className="col-lg-2">
                    <div className="row">
                        <div className="fv-row">
                            <SelectBox
                                name="vendorLookups"
                                dataSource={orderNoLookups}
                                valueExpr="id"
                                displayExpr="name"
                                searchEnabled={true}
                                onValueChanged={onValueChangedOrderNo}
                                showClearButton={true} />
                        </div>
                    </div>
                </div>
            </div>

            <React.Fragment>
                <DataGridWrapper
                    props={{ ref: dataGridRef }}
                    datasource={store}
                    remoteOperations={false}
                    showColumnLines={true}
                    columnChooser={true}
                    pagerVisible={true}
                    filterVisible={true}
                    headerFilterVisible={true}
                    keyboardNavigation={true}
                    excellExport={true}
                    onFocusedCellChanging={onFocusedCellChanging}
                    editingConfig={{
                        mode: "batch",
                        useIcons: true,
                        allowAdding: false,
                        allowDeleting: false,
                        allowUpdating: false,
                        updateMessageText: RemoveMessage('Resource'),
                    }}

                    columns={[
                        {
                            dataField: 'invoiceNo',
                            caption: t("syncflow:lb_invoice_no"),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'invoiceDate',
                            caption: t("syncflow:lb_invoice_date"),
                            allowFiltering: true,
                            allowEditing: false,
                            dataType: 'date',
                        },
                        {
                            dataField: 'orderCode',
                            caption: t("syncflow:ti_orders"),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'waybillNo',
                            caption: t("syncflow:ti_waybills"),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'deliveryDate',
                            caption: t("syncflow:lb_delivery_date"),
                            allowFiltering: true,
                            allowEditing: false,
                            dataType: 'date',
                        },

                        {
                            dataField: 'customerName',
                            caption: t("syncflow:lb_customer"),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'locationName',
                            caption: "Ship To",
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'ReceivedBy',
                            caption: "Received By",
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'comments',
                            caption: "Comments",
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'invoiceProductCount',
                            caption: t('syncflow:lb_product_count'),
                            allowFiltering: true,
                            allowEditing: false,
                            // cellRender: (data: any) => {
                            //     let account = data.row.data;
                            //     return (
                            //         <OrderStatusCell statusCode={account?.invoiceStatus} isAllApproved={account?.invoiceQty == account?.receivedQty} label={(account?.invoiceProductCount + " / " + account?.receivedProductCount)} />
                            //     )
                            // },
                        },
                        {
                            dataField: 'invoiceQty',
                            caption: t('syncflow:lb_qty'),
                            allowFiltering: true,
                            allowEditing: false,
                            // cellRender: (data: any) => {
                            //     let account = data.row.data;
                            //     return (
                            //         <OrderStatusCell statusCode={account?.invoiceStatus} isAllApproved={account?.invoiceQty == account?.receivedQty} label={(account?.invoiceQty + " / " + account?.receivedQty)} />
                            //     )
                            // },
                        },
                        {
                            dataField: 'invoiceAmount',
                            caption: t('syncflow:lb_amount'),
                            allowFiltering: true,
                            allowEditing: false,
                            format: { style: "currency", currency: "USD", useGrouping: true }
                            // cellRender: (data: any) => {
                            //     let account = data.row.data;
                            //     return (
                            //         <OrderStatusCell statusCode={account?.invoiceStatus} isAllApproved={account?.invoiceQty == account?.receivedQty} label={("$ " + account?.invoiceAmount + " / " + "$ " + account?.receivedAmount)} />
                            //     )
                            // },
                        },
                        {
                            dataField: 'invoiceStatus',
                            caption: t('syncflow:lb_order_status'),
                            allowFiltering: true,
                            allowEditing: false,
                            cellRender: (data: any) => {
                                let account = data.row.data;
                                return (
                                    <OrderStatusCell statusCode={account?.invoiceStatus} label={t('syncflow:lb_order_supplier_status_' + account?.invoiceStatus)} ></OrderStatusCell>
                                )
                            },
                        },
                        {
                            caption: t('syncflow:lb_detail'),
                            allowFiltering: false,
                            allowEditing: false,
                            cellRender: (data: any) => {
                                return (
                                    <Button
                                        text={t("syncflow:btn_detail")}
                                        type="default"
                                        icon='showpanel'
                                        stylingMode="contained"
                                        onClick={() => goToDetail(data.key.id)}
                                    />
                                );
                            },
                        },
                        {
                            caption: "Pdf",
                            allowFiltering: false,
                            allowEditing: false,
                            cellRender: (data: any) => {
                                return (
                                    <Button
                                        text="Download"
                                        type="default"
                                        icon='download'
                                        stylingMode="contained"
                                        onClick={() => goToDownload(data.key.id, data.key.invoicePdf)}
                                    />
                                );
                            },
                        },
                        // {
                        //     caption: "Slip",
                        //     allowFiltering: false,
                        //     allowEditing: false,
                        //     cellRender: (data: any) => {
                        //         return (
                        //             <Button
                        //                 text="Download"
                        //                 type="default"
                        //                 icon='download'
                        //                 stylingMode="contained"
                        //                 onClick={() => goToDownload(data.key.id, data.key.invoiceSlip)}
                        //             />
                        //         );
                        //     },
                        // }
                    ]}
                />
            </React.Fragment>

        </>


    )
}
export default InvoiceList